import { useAuthStore } from '@/shared/model';
import { outreachPresenceLabel, useOutreachPresence } from '@/entities/outreach-draft';
import * as s from './OutreachStepCrumbs.css';

/**
 * 「○○님이 작업 중 · US」 — IA §3-7, 퀘스트 `7d48a226`.
 *
 * 같은 캠페인의 발송 초안을 지금 만지는 다른 사람을 알린다. 편집을 막거나 읽기 전용으로 바꾸지
 * 않는다. 아무도 없으면 자리를 그리지 않는다.
 */
export function OutreachPresenceNote({ scenarioId }: { scenarioId: string }) {
  const selfId = useAuthStore((state) => state.user?.id);
  const presence = useOutreachPresence(scenarioId);
  const label = outreachPresenceLabel(presence.data?.items ?? [], selfId);
  if (label === null) return null;
  return (
    <p className={s.presence} role="status">
      {label}
    </p>
  );
}
